import { render } from "./ProfileDeleted.vue?vue&type=template&id=cf1fd2fa"
import script from "./ProfileDeleted.vue?vue&type=script&lang=js"
export * from "./ProfileDeleted.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__